import { VALID_PASSWORD, INVALID_PASSWORD } from '../actionTypes';
import { loginActions } from '../reducer';

export default (event) => (dispatch) => {
    const password = event.target.value;

    if (password.length >= 8) {
        dispatch(loginActions[VALID_PASSWORD]());
    } else {
        dispatch(loginActions[INVALID_PASSWORD]());
    }
};
